module.exports = __webpack_public_path__ + "static/media/fire.ceaba4bc.png";